import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class LoginService {

  constructor(
    private http: HttpClient,
  ) {}

  login(data) {
    return this.http.post<any>(environment.base_url + '/auth/login', data);
  }

}
